var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
const SpacerStyle = styled.div `
  ${props => props.horizontal &&
    css `
      display: inline-block;
      height: 0;
      width: ${props.double
        ? props.theme.spacings.doubleSpacing
        : props.half
            ? props.theme.spacings.halfSpacing
            : props.customSize
                ? props.customSize
                : props.theme.spacings.standardSpacing};
    `}
  ${props => props.vertical &&
    css `
      display: block;
      height: ${props.double
        ? props.theme.spacings.doubleSpacing
        : props.half
            ? props.theme.spacings.halfSpacing
            : props.customSize
                ? props.customSize
                : props.theme.spacings.standardSpacing};
      width: 0;
    `}
`;
const Spacer = (_a) => {
    var { horizontal = true, vertical = false, double = false, half = false, customSize } = _a, props = __rest(_a, ["horizontal", "vertical", "double", "half", "customSize"]);
    return (_jsx(SpacerStyle, Object.assign({ customSize: customSize, horizontal: horizontal, vertical: vertical, double: double, half: half }, props)));
};
export default Spacer;
